export const termsAndConditionsUtil = (): string => {
  const url = window.location.host
  switch (true) {
    case url.includes('eyeqmarketplace'): {
      return 'https://public-files-eyeq.s3.eu-west-2.amazonaws.com/4969CAR+Haulage+TSA+Service+Level+Agreement.pdf'
      break
    }
    default: {
      return 'https://public-files-zeuslabs.s3.eu-west-2.amazonaws.com/zeus-terms-of-use.pdf'
    }
  }
}
